import React from 'react';
import { Link } from 'react-router-dom';
import membersData from './membersData';
import TeamMember from './TeamMember';

function Team() {
  return (
    <section className="our-team-wrapper section-padding">
      <div className="container">
        <div className="team-top-content">
          <div className="section-head">
            <span className="heading-bg">Team</span>
            <h2 className="section-title mb-20">
              Our professionals will help you
              <span className="heading-dot" />
            </h2>
          </div>
          <Link to="/" className="button button-primary">
            Learn more
          </Link>
        </div>
      </div>
      <div className="row">
        <div className="container-fluid">
          <div className="team-card-wrapper">
            <div className="row py-4 gy-4 gy-lg-0">
              {membersData.map((member) => (
                <TeamMember
                  key={member.id}
                  thumb={member.thumb}
                  name={member.name}
                  role={member.role}
                  profileLink={member.profileLink}
                  fbUrl={member.fbUrl}
                  instaUrl={member.instaUrl}
                  twitterUrl={member.twitterUrl}
                />
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Team;
